<template>
  <v-main class="tpadding">
    <v-container fluid>
      <v-card class="rounded-xl elevation-5">
        <v-toolbar dense dark color="pinkKonect" elevation="2">
          <v-toolbar-title>Empleados y rutas</v-toolbar-title>
          <v-spacer></v-spacer>
          <sbtn text="Nuevo usuario" :onClick="newUser" icon="mdi-plus" colorBtn="white" typeButton="text" :load="loading" :disabled="(clientSearch !== '' ? false : true) || !isWriting" />
          <sbtn text="Ayuda" :onClick="helpActive" icon="mdi-help-circle-outline" colorBtn="white" typeButton="text" :load="loading" :disabled="clientSearch !== '' ? false : true" />
          <sbtn text="Carga masiva" :onClick="massiveActive" icon="mdi-upload" colorBtn="white" typeButton="text" :load="loading" :disabled="(clientSearch !== '' ? false : true) || !isWriting" />
          <sbtn text="Descargas" :onClick="layoutInfo" icon="mdi-download" colorBtn="white" typeButton="text" :load="loading" :disabled="clientSearch !== '' ? false : true" />
        </v-toolbar>
        <v-card-title>
          <v-text-field class="pa-5 mt-0" v-model="search" label="Buscar" single-line hide-details clearable></v-text-field>
          <v-spacer></v-spacer>
          <v-autocomplete
            v-model="clientSearch"
            :items="clientItem"
            item-text="nombre_comercial"
            item-value="idcliente_externo"
            label="Clientes"
            hide-details
            prepend-icon="mdi-account-group"
            @change="refresh()"
          ></v-autocomplete>
        </v-card-title>
        <v-card-text>
          <v-data-table
            :headers="headers"
            :items="items"
            :loading="loading"
            :search="search"
            :items-per-page="5"
            :footer-props="{
              'items-per-page-text': 'Elementos por página',
              itemsPerPageAllText: 'Todos',
            }"
          >
            <template v-slot:[`item.all_routes`]="{ item }">
              <span v-text="item.rutas[0].nombre_ruta" />
              <infoBtn text="Ver más" :onClick="slotsActions" icon="mdi-plus" colorBtn="green" :permission="false" :data="['allClient', item]" />
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <infoBtn :icon="'mdi-eye'" :actionColor="'primary'" :text="'Detalle'" :data="item" :onClick="adminEmployee" :permission="!isWriting" />
              <infoBtn :icon="'mdi-close-thick'" :text="'Eliminar'" :actionColor="'error'" :data="item" :onClick="remove" :permission="!isRemoving" />
            </template>
            <template v-slot:[`footer.page-text`]="props">
              Página {{ props.pageStart }} - {{ props.pageStop }} de
              {{ props.itemsLength }}
            </template>
            <template v-slot:no-data> No hay información disponible </template>
            <template v-slot:no-results> No se obtuvieron resultados </template>
          </v-data-table>
        </v-card-text>
      </v-card>
      <v-dialog v-model="dialogs.massive" persistent max-width="400">
        <v-card class="rounded-xl elevation-16">
          <v-toolbar dense dark color="blueKonect" elevation="0">
            <v-toolbar-title>{{ "Carga masiva" }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <div>
              <v-btn small text :loading="loadingUpload" :disabled="loadingUpload || !fileInfo" color="white" @click="upload()">
                {{ "Aceptar" }}
                <v-icon right>
                  {{ "mdi-upload" }}
                </v-icon>
              </v-btn>
              <v-btn text small :loading="loadingUpload" :disabled="loadingUpload" @click="cancel()">
                Cerrar
                <v-icon right>mdi-close</v-icon>
              </v-btn>
            </div>
          </v-toolbar>
          <v-card-text class="scrollStyle" style="max-height: 300px; overflow: scroll; overflow-x: hidden">
            <slot name="header"></slot>
            <p class="mt-5 text-h6">{{ "Cargue su archivo" }}</p>
            <slot></slot>
            <v-file-input type="file" @click="fileSave($event)" id="file-input" counter show-size truncate-length="50" v-model="fileInfo"></v-file-input>
          </v-card-text>
        </v-card>
      </v-dialog>
      <simpleDialog
        :active="dialogs.new"
        :clickRemove="newEmployee"
        :clickCancel="cancel"
        btnColor="blueKonect"
        removeMsg="¿Esta seguro de agregar un nuevo empleado?"
        title="Nuevo empleado"
        btnMsgRemove="Agregar"
      />
      <simpleDialog :active="dialogs.remove" :clickRemove="remove" :clickCancel="cancel" :removeMsg="msgRemove" btnMsgRemove="Aceptar" />
      <simpleDialog :active="dialogs.routes" :clickRemove="remove" :clickCancel="cancel" removeMsg="" btnMsgRemove="Aceptar" title="Rutas de empleado" actionBtn toolButton>
        <v-list>
          <v-list-item-group color="blueKonect">
            <v-list-item v-for="(item, i1) in employeeRoutes" :key="i1">
              <v-list-item-content>
                <v-list-item-title v-text="item.idruta + '/' + item.nombre_ruta"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </simpleDialog>
      <simpleDialog :active="dialogs.layout" :clickCancel="cancel" removeMsg="Tipos de descargas" title="Descargas" toolButton actionBtn :maxWidth="800">
        <v-container>
          <v-row>
            <v-col :cols="$vuetify.breakpoint.mobile ? 12 : 6" xs="12">
              <csvButton :nameCSV="nameCSV" :dataCSV="itemsCSV" :load="loading" :onClick="dataCSV" downloadType="csv" text="Descargar registro de empleados" csvColor="blueKonect" size="medium" />
            </v-col>
            <v-col :cols="$vuetify.breakpoint.mobile ? 12 : 6" xs="12">
              <xlsx-workbook>
                <xlsx-sheet :collection="sheet.data" v-for="sheet in sheets" :key="sheet.name" :sheet-name="sheet.name" />
                <xlsx-download :filename="sheetName">
                  <v-btn text color="primary">Descargar XLSX de carga <v-icon class="pl-2">mdi-download</v-icon></v-btn>
                </xlsx-download>
              </xlsx-workbook>
            </v-col>
          </v-row>
        </v-container>
      </simpleDialog>
      <simpleDialog :active="dialogs.help" :clickCancel="cancel" removeMsg="Tu layout debe contener lo siguinte" title="Ayuda" toolButton actionBtn :maxWidth="800">
        <tablek
          :headers="layoutHeader"
          :items="layoutItems"
          :loading="loading"
          :search="search"
          :onRemove="adminEmployee"
          :onRemove2="remove"
          :clickCancel="cancel"
          :slotsActions="slotsActions"
          removeMsg="¿Está seguro que desea eliminar el usuario?"
          slots=""
          hideFooter
        />
      </simpleDialog>
      <v-snackbar v-model="success" color="success" :timeout="2500" bottom right>
        {{ msgSuccess }}
      </v-snackbar>
      <v-snackbar v-model="error" color="error" :timeout="2500" bottom right style="white-space: pre-line">
        {{ errorList[codeError] }}
        {{ "\n\n" + this.codeError }}
      </v-snackbar>
    </v-container>
  </v-main>
</template>

<script>
import services from "@/utils/services";
import { tablek, errormsg, simpleDialog, infoBtn, csvButton, sbtn } from "@/components";
import { XlsxWorkbook, XlsxSheet, XlsxDownload } from "vue-xlsx";
import errorList from "@/utils/errorsList";

export default {
  name: "Clientes",
  components: {
    tablek,
    errormsg,
    simpleDialog,
    csvButton,
    sbtn,
    infoBtn,
    XlsxWorkbook,
    XlsxSheet,
    XlsxDownload,
  },
  data: () => ({
    visible: false,
    loading: false,
    loadingUpload: false,
    success: false,
    msgSuccess: "",
    errorList,
    codeError: "",
    code: "",
    state: "",
    itemDelete: "",
    stateValue: [
      {
        text: "Activo",
        value: 1,
      },
      {
        text: "Todos",
        value: 2,
      },
    ],
    idcliente: null,
    error: false,
    fileInfo: undefined,
    msgError: "",
    search: "",
    saveUpload: undefined,
    msgRemove: "¿Está seguro que desea desactivar al usuario?",
    nameCSV: "Empleados y rutas",
    layoutHeader: [
      {
        text: "Campo",
        align: "center",
        sortable: true,
        value: "camp",
      },
      {
        text: "Descripcion",
        align: "center",
        sortable: true,
        value: "descrption",
      },
    ],
    layoutItems: [
      {
        camp: "idruta",
        descrption: "Numero de unidad de ruta la puedes visulizar en los mapas",
      },
      {
        camp: "referencia_empleado",
        descrption: "Numero unico dde identificacion para empleado(ejemplo numero de nomina)",
      },
      { camp: "nombre_empleado", descrption: "Nombre(s) de empleado" },
      { camp: "apellido_empleado", descrption: "Apellido(s) de empleado" },
      {
        camp: "campo_flex_1",
        descrption: "Campo disponible para dato alterno(imss, departamento, curp, fecha_ingreso, etc)",
      },
      {
        camp: "campo_flex_2",
        descrption: "Campo disponible para dato alterno(imss, departamento, curp, fecha_ingreso, etc)",
      },
      {
        camp: "campo_flex_3",
        descrption: "Campo disponible para dato alterno(imss, departamento, curp, fecha_ingreso, etc)",
      },
      {
        camp: "campo_flex_4",
        descrption: "Campo disponible para dato alterno(imss, departamento, curp, fecha_ingreso, etc)",
      },
      {
        camp: "campo_flex_5",
        descrption: "Campo disponible para dato alterno(imss, departamento, curp, fecha_ingreso, etc)",
      },
    ],
    headers: [
      {
        text: "Referencia",
        align: "center",
        sortable: true,
        value: "referencia_empleado",
      },
      {
        text: "Nombre",
        align: "center",
        sortable: true,
        value: "nombre_empleado",
      },
      {
        text: "Apellido",
        align: "center",
        sortable: true,
        value: "apellido_empleado",
      },
      {
        text: "Campo flex 1",
        align: "center",
        sortable: true,
        value: "campo_flex_1",
      },
      {
        text: "Campo flex 2",
        align: "center",
        sortable: true,
        value: "campo_flex_2",
      },
      {
        text: "Campo flex 3",
        align: "center",
        sortable: true,
        value: "campo_flex_3",
      },
      {
        text: "Campo flex 4",
        align: "center",
        sortable: true,
        value: "campo_flex_4",
      },
      {
        text: "Campo flex 5",
        align: "center",
        sortable: true,
        value: "campo_flex_5",
      },
      {
        text: "Ruta",
        align: "center",
        sortable: true,
        value: "all_routes",
      },
      {
        text: "Acciones",
        align: "center",
        sortable: true,
        value: "actions",
      },
    ],
    items: [],
    itemsAux: [],
    itemsCSV: [],
    employeeRoutes: [],
    clientItem: [],
    clientSearch: "",
    dialogs: {
      remove: false,
      massive: false,
      routes: false,
      new: false,
      layout: false,
      help: false,
    },
    rules: {
      required: (v) => !!v || "El campo es obligatorio",
      max13: (v) => (v || "").length <= 13 || "Limite de caracteres",
      max200: (v) => (v || "").length <= 200 || "Limite de caracteres",
      number: (v) => {
        if (!!v && v !== "") {
          return /^[0-9]+$/.test(v) || "Número inválido";
        } else {
          return true;
        }
      },
      email: (v) => {
        if (v !== "") {
          return /.+@.+\..+/.test(v) || "Correo inválido";
        } else {
          return true;
        }
      },
    },
    file: null,
    selectedSheet: null,
    sheetName: "Empleados y rutas" + "-" + new Date().getDate() + "-" + new Date().getMonth() + "-" + new Date().getFullYear() + ".xlsx",
    sheets: [
      {
        name: "Empleados y Rutas",
        data: [
          {
            idruta: "Campo Requerido",
            referencia_empleado: "Campo Requerido",
            nombre_empleado: "",
            apellido_empleado: "",
            campo_flex_1: "",
            campo_flex_2: "",
            campo_flex_3: "",
            campo_flex_4: "",
            campo_flex_5: "",
          },
        ],
      },
    ],
  }),
  mounted() {
    if (this.isReading) {
      this.getClients();
    }
  },
  computed: {
    isReading: function () {
      return services.check(1, this.$route.path);
    },
    isWriting: function () {
      return services.check(2, this.$route.path);
    },
    isRemoving: function () {
      return services.check(3, this.$route.path);
    },
  },
  methods: {
    refresh() {
      this.loading = true;
      let jwt = this.$session.get("jwt");
      let headers = {
        Authorization: "Bearer " + jwt,
      };
      this.axios
        .get(services.routes.empByCli + "/" + this.clientSearch, {
          headers,
        })
        .then((response) => {
          this.items = response.data.data;
        })
        .catch((error) => {
          this.error = true;
          this.codeError = error.response.data.code;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getClients() {
      this.loading = true;
      services
        .ws("get", "clients")
        .then((res) => {
          this.itemsAux = res.data;
          this.clientItem = res.data;
          if (this.clientItem) {
            this.clientSearch = this.clientItem[0].idcliente_externo;
          }
          this.refresh();
        })
        .catch((error) => {
          this.error = true;
          this.codeError = error.response.data.code;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    upload() {
      this.loadingUpload = true;
      services
        .ws("postFile", "bulk", null, null, this.saveUpload)
        .then((res) => {
          this.cancel();
          this.refresh();
          this.success = true;
          this.msgSuccess = "Registro guardado exitosamente";
        })
        .catch((error) => {
          this.error = true;
          this.codeError = error.response.data.code;
        })
        .finally(() => {
          this.loadingUpload = false;
          this.fileInfo = undefined;
        });
    },
    slotsActions(data) {
      if (data[0] == "allClient") {
        this.allClient(data[1]);
      }
    },
    allClient(item) {
      this.employeeRoutes = item.rutas;
      this.dialogs.routes = true;
    },
    fileSave(event) {
      this.saveUpload = event;
    },
    dataCSV(type) {
      this.itemsCSV = [];
      if (this.items.length > 0 && type == "csv") {
        this.nameCSV = "Empleados y rutas" + "-" + new Date().getDate() + "-" + new Date().getMonth() + "-" + new Date().getFullYear() + ".csv";
        for (let i = 0; i < this.items.length; i++) {
          this.itemsCSV.push({
            Referencia_empleado: this.items[i].referencia_empleado,
            Nombre: this.items[i].nombre_empleado,
            Apellido: this.items[i].apellido_empleado,
            Nombre_comercial: this.items[i].cliente_nombre_coomercial,
            campo_flex_1: this.items[i].campo_flex_1,
            campo_flex_2: this.items[i].campo_flex_2,
            campo_flex_3: this.items[i].campo_flex_3,
            campo_flex_4: this.items[i].campo_flex_4,
            campo_flex_5: this.items[i].campo_flex_5,
            Ruta: this.items[i].rutas[0].nombre_ruta,
          });
        }
        this.success = true;
        this.msgSuccess = "Descargando documento";
      } else {
        this.itemsCSV = [];
        this.error = true;
        this.codeError = "CSV_NO_DATA";
      }
    },
    newUser() {
      this.dialogs.new = true;
    },
    layoutInfo() {
      this.dialogs.layout = true;
    },
    helpActive() {
      this.dialogs.help = true;
    },
    remove(item) {
      if (!this.dialogs.remove) {
        this.itemDelete = item;
        this.dialogs.remove = true;
      } else {
        this.loading = true;
        let data = {
          data: {
            idempleado_cliente_externo: this.itemDelete.idempleado_cliente_externo,
          },
        };
        services
          .ws("delete", "employeesProgram", data)
          .then((res) => {
            this.cancel();
            this.refresh();
            this.success = true;
            this.msgSuccess = "Cliente eliminada correctamente";
          })
          .catch((error) => {
            this.error = true;
            this.codeError = error.response.data.code;
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    cancel() {
      this.dialogs.massive = false;
      this.dialogs.remove = false;
      this.dialogs.routes = false;
      this.dialogs.new = false;
      this.dialogs.layout = false;
      this.dialogs.help = false;
      this.fileInfo = undefined;
    },
    massiveActive() {
      this.dialogs.massive = true;
    },
    adminEmployee(item) {
      this.$router.push("/client/administracionEmpleados/" + this.clientSearch + "/" + item.idempleado_cliente_externo);
    },
    newEmployee() {
      for (let i = 0; i < this.itemsAux.length; i++) {
        if (this.itemsAux[i].idcliente_externo == this.clientSearch) {
          this.$router.push("/client/nuevoEmpleado/" + this.itemsAux[i].idcliente_externo);
        }
      }
    },
    closeMsg() {
      this.error = false;
    },
  },
};
</script>

<style scoped>
.hola {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}
</style>
